export default __webpack_public_path__ + "static/1395-cff7e1bfc545b74579d02fc23a810f99.gif";